const data = [
    {
        img: "https://apollo-olx.cdnvideo.ru/v1/files/itjcj6ecf33z2-UZ/image;s=644x461",
        title: "Labo 2021 Rangi Oq",
        price: "8 490 у.е.",
        location: "Ташкент, Мирабадский район",
    },
    {
        img: "https://apollo-olx.cdnvideo.ru/v1/files/jmxzxfg57opo-UZ/image;s=644x461",
        title: "Captiva 4 sotiladi holati full",
        price: "26 500 у.е.",
        location: "Ташкент, Юнусабадский район",
    },
    {
        img: "https://apollo-olx.cdnvideo.ru/v1/files/y0xy7vpaj8ir-UZ/image;s=644x461",
        title: "Mercedes-Benz C-class C200 AMG-line W205 (Модельный год 2015)",
        price: "41 500 у.е.",
        location: "Ташкент, Шайхантахурский район",
    },
]

export default data;